module.exports = __webpack_public_path__ + "img/chengyun88.2f128817.png";